import { useState } from 'react';

import { getRange } from '../utils/utils';

/**
 * Returns a handler to process multislect clicks.
 */
const useMultiselectClickHandler = () => {
  // Keep track of the previously clicked item for shift-clicks
  const [previousClickIndex, setPreviousClickIndex] = useState(null);

  const processClick = ({
    hasShiftKey,
    hasMetaKey,
    index,
    currentSelection, // number[]
    resetPreviousClick = false,
  }) => {
    // If not currently shift-clicking, save this click for later.
    if (!hasShiftKey) setPreviousClickIndex(index);
    // Otherwise, if we're resetting the previous click, clear it.
    else if (resetPreviousClick) setPreviousClickIndex(null);

    const canShiftClick = previousClickIndex !== null && !resetPreviousClick;

    if (hasShiftKey && canShiftClick) {
      // Select all items between the previous click and this one.
      const range = getRange(previousClickIndex, index);

      if (hasMetaKey) {
        // Add these to the existing selection
        return [...currentSelection, ...range];
      }

      // Just select the new range
      return range;
    }

    if (hasMetaKey) {
      // Toggle this item
      return currentSelection.includes(index)
        ? currentSelection.filter((i) => i !== index)
        : [...currentSelection, index];
    }

    // Select just this item.
    return [index];
  };

  return processClick;
};

export default useMultiselectClickHandler;
